import { render, staticRenderFns } from "./CommentCell.vue?vue&type=template&id=9f2e498e"
import script from "./CommentCell.vue?vue&type=script&lang=js"
export * from "./CommentCell.vue?vue&type=script&lang=js"
import style0 from "./CommentCell.vue?vue&type=style&index=0&id=9f2e498e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports